import { AbsenceType } from "@/api/AbsenceType";
import { CompensationInhabitant } from "@/api/Compensation";
import { SickInhabitant } from "@/api/Sick";
import { VacationInhabitant } from "@/api/Vacation";
import { IconType } from "react-icons";
import { LuAmbulance, LuClock, LuTreePalm } from "react-icons/lu";

export interface AbsenceTypeDetail {
  type: AbsenceType;
  name: string;
  color: string;
  icon: IconType;
  detail?: string;
}

export const absenceData: AbsenceTypeDetail[] = [
  {
    type: VacationInhabitant,
    name: "Ferien",
    color: "#9FEE33", // green
    icon: LuTreePalm,
  },
  {
    type: CompensationInhabitant,
    name: "Kompensation",
    color: "#FFB533", // orange
    icon: LuClock,
  },
  {
    type: SickInhabitant,
    name: "Krankheit",
    color: "#FF33B5", // rosa
    icon: LuAmbulance,
  },
];
